import { Badge } from '@/components/ui/badge'
import { AlertCircle } from 'lucide-react'

/**
 * Help content specific to interactive tools
 */
export function ToolHelp() {
    return (
        <>
            <h3 className="font-medium text-lg mb-2">Publishing Interactive Tools</h3>
            <ol className="list-decimal pl-5 space-y-3 mb-4">
                <li>
                    <strong>Embed on Website:</strong> Click the <Badge variant="outline" className="ml-1 mr-1 font-normal">Share & Embed</Badge> button to get embeddable iframe code 
                    that can be added to any webpage.
                </li>
                <li>
                    <strong>Direct Link:</strong> Use the <Badge variant="outline" className="ml-1 mr-1 font-normal">Share & Embed → Copy URL</Badge> option to get a direct link 
                    that can be shared with users.
                </li>
                <li>
                    <strong>JavaScript Integration:</strong> For advanced usage, you can use the JS URL option to 
                    programmatically integrate this tool with your existing web application.
                </li>
                <li>
                    <strong>Testing:</strong> Thoroughly test all interactive elements and calculations to ensure they function correctly before sharing.
                </li>
            </ol>
            
            <div className="bg-amber-50 dark:bg-amber-950/30 p-3 rounded-md border border-amber-200 dark:border-amber-800 mb-4">
                <h4 className="font-medium text-amber-800 dark:text-amber-400 flex items-center gap-2 mb-2">
                    <AlertCircle className="h-4 w-4" />
                    Interactive Tool Integration Note
                </h4>
                <p className="text-sm text-amber-700 dark:text-amber-300">
                    When embedding tools, ensure you use the correct sandbox permissions in the iframe if your tool requires user inputs or form submissions.
                    The default embed code includes these permissions, but you may need to adjust them depending on your specific requirements.
                </p>
            </div>
        </>
    )
}